import { ActionTypes } from '../../constants/ActionTypes';
import { IConfirmSendLetter, ISendLetter } from '../../interfaces/SendLetter';

export const onSendLetter = (sendLetterModel: ISendLetter) => {
  return {
    type: ActionTypes.SEND_LETTER,
    payload: sendLetterModel,
  };
};

export const onSendLetterSuccess = (sendLetterModel: IConfirmSendLetter) => {
  return {
    type: ActionTypes.SEND_LETTER_SUCCESS,
    payload: sendLetterModel,
  };
};

export const onChangeSendLetterStatus = () => {
  return {
    type: ActionTypes.CHANGE_SEND_LETTER_STATUS,
  };
};
